<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="udXWe255T6b5lvjqfcC9ct9">
<p class="CHAPTER1" id="ucu7QS845MPh3AEZE9UYx79"><a id="uXFWzHP8eUHnzGrzdDbntU5"></a>PROLOGUE</p>
<p class="FIRSTPARAGRAPH">A red Ford 4x4 F150 pickup truck pulls to a stop on Washington Street in Ayer, Massachusetts with its left blinker on, awaiting the oncoming traffic. Once the last car passes, the truck pulls into an apartment complex parking lot. In the truck is Green Beret William Tyree and his wife, Elaine. They pull into a parking spot and Elaine gets out of the vehicle. She walks over to the driver’s side of the truck, gives her husband a kiss, and proceeds to head up the front stairs to her apartment building. She waves to him as she heads into the building and he waves back as he begins to pull back out onto Washington Street.</p>
<p class="Normal">Suddenly, the silence of the afternoon is broken when Elaine’s voice is heard screaming, “Get out of here! Leave me alone!” The neighbor in the next apartment phones the police and attempts to get a response from the apartment but to no avail.</p>
<p class="Normal">Once the landlord is reached, he goes to the building to open the apartment for the police. There are traces of blood splatter on the door and in the hallway outside the apartment. When the door is opened, no one expects to see Elaine Tyree lying face up in her army fatigues. The apartment shows signs of a struggle. Clean laundry is strewn about and a lamp has been knocked over. The scene provokes skepticism in the investigators. Did Elaine Tyree walk in on an attempted robbery or was someone she knew behind her murder?</p>
<p class="Normal">Everyone present that day at 104 ½ Washington Street, Apartment 1 soon finds themselves plunged into an eerie netherworld of secrets and lies, as new and mystifying leads suggest that the crime could have been perpetrated by the US government.</p>
<p class="Normal">Not only does this murder shake a sleepy New England town to its core, but it also has far-reaching implications concerning the United States Army, the Ayer Police Department, the US Army Criminal Investigation Division, and the Massachusetts judicial system.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?6927216a